import { jsx as _jsx } from "react/jsx-runtime";
import clsx from "clsx";
import {} from "react";
import { wrapTextNodeSiblings } from "../../lib/renderHelpers";
import {} from "../../types";
import s from "./Badge.module.css";
export const Badge = ({ children, className, variant = "soft", color = "secondary", size = "sm", pill, ...restMaybeAsChildProps }) => {
    return (_jsx("div", { className: clsx(s.Badge, className), "data-color": color, "data-size": size, "data-pill": pill ? "" : undefined, "data-variant": variant, ...restMaybeAsChildProps, children: wrapTextNodeSiblings(children) }));
};
//# sourceMappingURL=index.js.map